import React from "react"
import { Outlet } from "react-router-dom"
import VerificationHeader from '../components/globals/VerificationHeader'
import Toaster from "../components/globals/Toaster"
import { ModalRootElement } from "../components/elements/Modal"

// tailwind css
import '../index.css'

const VerificationLayout: React.FC = (): React.ReactElement => {
  return (
    <div className="ui-panel-view flex h-full w-full flex-col overflow-hidden">
      <VerificationHeader />
      <div className="ui-layout-wrapper block min-h-0 w-full flex-1 overflow-y-auto overflow-x-hidden px-[28px]"><Outlet /></div>
      <Toaster />
      <ModalRootElement />
    </div>
  )
}

export default VerificationLayout
